/**
 * Prevelo Bold Options Refresh - Balanced Approach
 * 
 * This script ensures each item gets a unique Bold Builder ID by:
 * 1. Clearing existing Builder IDs when the cart drawer closes
 * 2. Ensuring a Builder ID is present when an item is added to the cart
 */

document.addEventListener('DOMContentLoaded', function() {
  console.log('Initializing Balanced Bold Options Refresh');
  
  // Track if we've cleared the builder IDs
  let builderIdsCleared = false;
  
  // Listen for cart drawer close events
  document.addEventListener('on:cart-drawer:after-close', function() {
    console.log('Cart drawer closed, clearing Bold Builder IDs');
    
    // Clear any existing Bold Builder IDs from the page
    clearBoldBuilderIds();
    
    // Force Bold to generate a new Builder ID for the next item
    if (window.BOLD && BOLD.options) {
      // Reset any active builder ID
      if (BOLD.options.activeBuilderID !== undefined) {
        BOLD.options.activeBuilderID = null;
        console.log('Reset Bold active Builder ID');
      }
      
      // Clear any stored builder IDs
      if (BOLD.options.builderIDs) {
        BOLD.options.builderIDs = {};
        console.log('Cleared Bold Builder IDs object');
      }
      
      // Try to reinitialize Bold Options
      if (typeof BOLD.options.reinit === 'function') {
        BOLD.options.reinit();
        console.log('Bold Options reinitialized');
      }
    }
    
    // Use the event emitter to force a refresh
    if (window.BOLD && BOLD.common && BOLD.common.eventEmitter) {
      BOLD.common.eventEmitter.emit('BOLD_COMMON_variant_changed');
      console.log('Bold Options refreshed via event emitter');
    }
    
    // Mark that we've cleared the builder IDs
    builderIdsCleared = true;
  });
  
  // Add a click event listener to the Add to Cart button
  document.addEventListener('click', function(event) {
    // Check if the clicked element is the Add to Cart button
    if (event.target.matches('button[name="add"]') || event.target.closest('button[name="add"]')) {
      console.log('Add to Cart button clicked');
      
      // If we've cleared the builder IDs, we need to ensure a new one is generated
      if (builderIdsCleared) {
        console.log('Builder IDs were cleared, ensuring a new one is generated');
        
        // Force Bold to generate a new Builder ID
        if (window.BOLD && BOLD.options) {
          // Try to generate a new Builder ID
          if (typeof BOLD.options.generateBuilderId === 'function') {
            BOLD.options.generateBuilderId();
            console.log('Generated new Bold Builder ID');
          }
          
          // If that doesn't work, try to reinitialize Bold Options
          if (typeof BOLD.options.reinit === 'function') {
            BOLD.options.reinit();
            console.log('Bold Options reinitialized');
          }
        }
        
        // Add a Builder ID to the form
        const form = event.target.closest('form[action*="/cart/add"]');
        if (form) {
          addBuilderIdToForm(form);
        }
        
        // Reset the flag
        builderIdsCleared = false;
      }
    }
  });
  
  // Use a MutationObserver to detect when Bold Options adds new elements to the page
  const observer = new MutationObserver(function(mutations) {
    // If we've cleared the builder IDs, check for new Bold Options elements
    if (builderIdsCleared) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length) {
          // Check if any of the added nodes are Bold Options elements
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // Element node
              // Check if this is a Bold Options element
              if (node.classList && node.classList.contains('bold_options')) {
                console.log('Bold Options element added to the page');
                
                // Force Bold to generate a new Builder ID
                if (window.BOLD && BOLD.options) {
                  // Try to generate a new Builder ID
                  if (typeof BOLD.options.generateBuilderId === 'function') {
                    BOLD.options.generateBuilderId();
                    console.log('Generated new Bold Builder ID');
                  }
                }
              }
              
              // Check if this element contains Bold Options elements
              const boldOptions = node.querySelectorAll('.bold_options');
              if (boldOptions.length > 0) {
                console.log('Element containing Bold Options added to the page');
                
                // Force Bold to generate a new Builder ID
                if (window.BOLD && BOLD.options) {
                  // Try to generate a new Builder ID
                  if (typeof BOLD.options.generateBuilderId === 'function') {
                    BOLD.options.generateBuilderId();
                    console.log('Generated new Bold Builder ID');
                  }
                }
              }
            }
          });
        }
      });
    }
  });
  
  // Start observing the document
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  /**
   * Adds a Builder ID to a form
   * @param {HTMLFormElement} form - The form to add the Builder ID to
   */
  function addBuilderIdToForm(form) {
    if (!form) return;
    
    // Generate a unique Builder ID
    const builderId = 'builder_' + Math.random().toString(36).substring(2, 15) + 
                      Math.random().toString(36).substring(2, 15) + 
                      '_' + Date.now();
    
    // Check if a Builder ID input already exists
    let builderIdInput = form.querySelector('input[name="properties[_boldBuilderId]"]');
    
    // If no Builder ID input exists, create it
    if (!builderIdInput) {
      builderIdInput = document.createElement('input');
      builderIdInput.type = 'hidden';
      builderIdInput.name = 'properties[_boldBuilderId]';
      form.appendChild(builderIdInput);
    }
    
    // Set the Builder ID
    builderIdInput.value = builderId;
    
    console.log('Added Bold Builder ID to form:', builderId);
    
    // If Bold's API is available, try to update it there too
    if (window.BOLD && BOLD.options) {
      if (BOLD.options.builderIDs) {
        // Find the product ID
        const productIdInput = form.querySelector('input[name="id"]');
        if (productIdInput && productIdInput.value) {
          BOLD.options.builderIDs[productIdInput.value] = builderId;
        }
      }
      
      if (BOLD.options.activeBuilderID !== undefined) {
        BOLD.options.activeBuilderID = builderId;
      }
    }
  }
  
  /**
   * Clears all Bold Builder IDs from the page
   */
  function clearBoldBuilderIds() {
    // Find all Bold option forms
    const boldOptionsForms = document.querySelectorAll('.bold_options');
    if (boldOptionsForms.length > 0) {
      boldOptionsForms.forEach(form => {
        // Remove any stored builder IDs that might be in the form
        const builderIdInputs = form.querySelectorAll('input[name*="_boldBuilderId"]');
        builderIdInputs.forEach(input => {
          input.value = ''; // Clear the builder ID
          input.remove(); // Remove the input entirely
        });
        
        // Clear any data attributes that might store builder IDs
        if (form.dataset) {
          Object.keys(form.dataset).forEach(key => {
            if (key.toLowerCase().includes('bold') || key.toLowerCase().includes('builder')) {
              delete form.dataset[key];
            }
          });
        }
        
        // Remove any builder ID attributes
        form.removeAttribute('data-bold-builder-id');
        form.removeAttribute('data-builder-id');
      });
      console.log('Bold Builder IDs cleared from Bold option forms');
    }
    
    // If there's a product form, ensure it's using a fresh Bold Builder ID
    const productForms = document.querySelectorAll('form[action*="/cart/add"]');
    productForms.forEach(form => {
      // Look for hidden inputs that might store Bold Builder IDs
      const hiddenInputs = form.querySelectorAll('input[type="hidden"]');
      hiddenInputs.forEach(input => {
        if (input.name && (
            input.name.includes('_boldBuilderId') || 
            input.name.includes('properties[_boldBuilderId]') ||
            input.name.includes('properties[_builder')
        )) {
          input.value = ''; // Clear the builder ID
          input.remove(); // Remove the input entirely
        }
      });
      
      // Clear any data attributes that might store builder IDs
      if (form.dataset) {
        Object.keys(form.dataset).forEach(key => {
          if (key.toLowerCase().includes('bold') || key.toLowerCase().includes('builder')) {
            delete form.dataset[key];
          }
        });
      }
    });
    console.log('Bold Builder IDs cleared from product forms');
  }
});
